import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseurl } from './utility/helper';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px',
  },
  wrapper: {
    width: '100%',
    maxWidth: '440px',
    overflow: 'auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  logoContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70px',
    height: '70px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '20px',
    marginBottom: '20px',
    boxShadow: '0 10px 25px rgba(102, 126, 234, 0.3)',
  },
  logoIcon: {
    width: '35px',
    height: '35px',
    color: '#fff',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#fff',
    marginBottom: '10px',
    margin: '0',
  },
  subtitle: {
    fontSize: '15px',
    color: 'rgba(255, 255, 255, 0.9)',
    margin: '0',
  },
  card: {
    background: '#fff',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  alert: {
    padding: '15px',
    borderRadius: '10px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  alertError: {
    background: '#fee',
    borderLeft: '4px solid #dc3545',
  },
  alertSuccess: {
    background: '#d4edda',
    borderLeft: '4px solid #28a745',
  },
  alertIcon: {
    width: '20px',
    height: '20px',
    flexShrink: '0',
    marginTop: '2px',
  },
  alertText: {
    fontSize: '14px',
    fontWeight: '500',
    margin: '0',
    flex: '1',
  },
  alertSubtext: {
    fontSize: '12px',
    marginTop: '4px',
    opacity: '0.8',
  },
  inputGroup: {
    marginBottom: '24px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px',
  },
  inputWrapper: {
    position: 'relative',
  },
  inputIcon: {
    position: 'absolute',
    left: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '20px',
    height: '20px',
    color: '#999',
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    padding: '14px 14px 14px 45px',
    fontSize: '15px',
    border: '2px solid #e0e0e0',
    borderRadius: '10px',
    outline: 'none',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
  },
  inputFocus: {
    borderColor: '#667eea',
  },
  inputDisabled: {
    background: '#f5f5f5',
    color: '#999',
    cursor: 'not-allowed',
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    color: '#667eea',
    marginBottom: '20px',
  },
  spinner: {
    width: '20px',
    height: '20px',
    border: '3px solid #667eea',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  loaderText: {
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  button: {
    width: '100%',
    padding: '14px 20px',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
  },
  buttonPrimary: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
  },
  buttonPrimaryHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
  },
  buttonSecondary: {
    background: '#fff',
    color: '#667eea',
    border: '2px solid #667eea',
  },
  buttonSecondaryHover: {
    background: '#f8f9ff',
  },
  buttonDisabled: {
    background: '#ddd',
    color: '#999',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  footer: {
    marginTop: '24px',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '13px',
    color: 'rgba(255, 255, 255, 0.9)',
    margin: '0',
  },
};

// Add keyframe animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

const Login = () => {
  const [userID, setUserID] = useState('');
  const [adminId, setAdminID] = useState('');
  const [userroleid, setUserRoleID] = useState('');
  const [userchapterid, setChapterID] = useState('');
  const [userchaptername, setChapterName] = useState('');
  const [username, setUserName] = useState('');
  const [mobileno, setMobileNo] = useState('');
  const [profileimg, setImgurl] = useState('');
  const [userroletype, setUserRoleType] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [enteredOtp, setEnteredOtp] = useState('');
  const [resendOTP, setResendOTP] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [hoveredButton, setHoveredButton] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOtpSent && !resendOTP) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            setResendOTP(true);
            return 30;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOtpSent, resendOTP]);

  const handleSendOtp = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseurl}/admin/send-otp`, { userID });
      setUserRoleID(response.data.userroleid);
      setChapterID(response.data.chapterid);
      setChapterName(response.data.chaptername);
      setUserRoleType(response.data.roletype);
      setAdminID(response.data.adminId);
      setUserName(response.data.username);
      setMobileNo(response.data.mobileno);
      setImgurl(response.data.profileimg);
      setIsOtpSent(true);
      setResendOTP(false);
      setCountdown(30);
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Error sending OTP. Please try again.');
    }
    setLoading(false);
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseurl}/admin/verify-otp`, {
        otp: enteredOtp,
        userId: userID,
      });
      if (response.data.success) {
        sessionStorage.setItem("token", response.data.token);
        sessionStorage.setItem('userId', userID);
        sessionStorage.setItem('userroleId', userroleid);
        sessionStorage.setItem('userchapterId', userchapterid);
        sessionStorage.setItem('userchaptername', userchaptername);
        sessionStorage.setItem('username', username);
        sessionStorage.setItem('mobileno', mobileno);
        sessionStorage.setItem('userroletype', userroletype);
        sessionStorage.setItem('adminId', adminId);
        sessionStorage.setItem('adminImg', profileimg);

        if (userroleid === 1) {
          navigate("/admin/dashboard");
        } else if (userroleid === 2) {
          navigate("/admin/memberlist");
        } else if (userroleid === 4) {
          navigate("/admin/TestList");
        } else if (userroleid === 5) {
          navigate("/admin/Transactionlist");
        } else if(userroleid === 3){
          navigate("/admin/dashboard");
        }else {
          navigate("/admin");
        }
      } else {
        setError('Invalid OTP. Please try again.');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Error verifying OTP. Please try again.');
    }
    setLoading(false);
  };

  const getButtonStyle = (buttonType, isDisabled) => {
    if (isDisabled) return { ...styles.button, ...styles.buttonDisabled };
    
    const baseStyle = buttonType === 'primary' 
      ? { ...styles.button, ...styles.buttonPrimary }
      : { ...styles.button, ...styles.buttonSecondary };
    
    if (hoveredButton === buttonType) {
      return {
        ...baseStyle,
        ...(buttonType === 'primary' ? styles.buttonPrimaryHover : styles.buttonSecondaryHover)
      };
    }
    
    return baseStyle;
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <div style={styles.header}>
          <div >
             <img src="/assets/img/mensatrans.png" className="img-fluid2 logo-blue" alt="Logo" />
          </div>
          <br></br>
          <h1 style={styles.title}>Admin Login</h1>
          <p style={styles.subtitle}>
            {isOtpSent ? 'Enter the OTP sent to your email' : 'Sign in to continue to your account'}
          </p>
        </div>

        <div style={styles.card}>
          {error && (
            <div style={{ ...styles.alert, ...styles.alertError }}>
              <svg style={{ ...styles.alertIcon, color: '#dc3545' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p style={{ ...styles.alertText, color: '#721c24' }}>{error}</p>
            </div>
          )}

          {isOtpSent && !error && (
            <div style={{ ...styles.alert, ...styles.alertSuccess }}>
              <svg style={{ ...styles.alertIcon, color: '#28a745' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div style={{ flex: 1 }}>
                <p style={{ ...styles.alertText, color: '#155724' }}>OTP sent successfully!</p>
                <p style={{ ...styles.alertSubtext, color: '#155724' }}>OTP sent to your email successfully</p>
              </div>
            </div>
          )}

          <div style={styles.inputGroup}>
            <label style={styles.label}>Enter Email</label>
            <div style={styles.inputWrapper}>
              <svg style={styles.inputIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {userID.includes('@') ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                )}
              </svg>
              <input
                type="text"
                placeholder="Enter email"
                value={userID}
                onChange={(e) => setUserID(e.target.value.toLowerCase())}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    isOtpSent ? handleVerifyOtp() : handleSendOtp();
                  }
                }}
                disabled={isOtpSent}
                style={{
                  ...styles.input,
                  ...(isOtpSent && styles.inputDisabled)
                }}
              />
            </div>
          </div>

          {isOtpSent && (
            <div style={styles.inputGroup}>
              <label style={styles.label}>One-Time Password</label>
              <div style={styles.inputWrapper}>
                <svg style={styles.inputIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <input
                  type="text"
                  placeholder="Enter 6-digit OTP"
                  value={enteredOtp}
                  onChange={(e) => setEnteredOtp(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      isOtpSent ? handleVerifyOtp() : handleSendOtp();
                    }
                  }}
                  maxLength={6}
                  style={styles.input}
                  
                />
              </div>
            </div>
          )}

          {loading && (
            <div style={styles.loader}>
              <div style={styles.spinner}></div>
              <span style={styles.loaderText}>Processing...</span>
            </div>
          )}

          <div style={styles.buttonGroup}>
            <button
              onClick={isOtpSent ? handleVerifyOtp : handleSendOtp}
              disabled={loading || (isOtpSent ? !enteredOtp : !userID)}
              onMouseEnter={() => setHoveredButton('primary')}
              onMouseLeave={() => setHoveredButton(null)}
              style={getButtonStyle('primary', loading || (isOtpSent ? !enteredOtp : !userID))}
            >
              {isOtpSent ? 'Verify OTP' : 'Send OTP'}
            </button>

            {isOtpSent && (
              <button
                onClick={handleSendOtp}
                disabled={!resendOTP || loading}
                onMouseEnter={() => setHoveredButton('secondary')}
                onMouseLeave={() => setHoveredButton(null)}
                style={getButtonStyle('secondary', !resendOTP || loading)}
              >
                {resendOTP ? 'Resend OTP' : `Resend OTP in ${countdown}s`}
              </button>
            )}
          </div>
        </div>

       
      </div>
    </div>
  );
};

export default Login;